function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1024 9.383v55.552H0V15.673C116.44-8.761 221.227 2.252 320.247 12.659c79.04 8.307 154.404 16.228 229.086 5.426 83.871-12.132 146.596-6.74 210.727-1.228 74.368 6.392 150.626 12.947 263.94-7.474z",
  fill: "#235544"
});

function SvgBlueFooterTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgdmlld0JveD0iMCAwIDEwMjQgNjUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMDI0IDkuMzgzMzNWNjQuOTM0NkgwVjE1LjY3MjhDMTE2LjQ0IC04Ljc2MTI1IDIyMS4yMjcgMi4yNTE5NiAzMjAuMjQ3IDEyLjY1ODlDMzk5LjI4NyAyMC45NjYxIDQ3NC42NTEgMjguODg2OSA1NDkuMzMzIDE4LjA4NDZDNjMzLjIwNCA1Ljk1MzIxIDY5NS45MjkgMTEuMzQ0NiA3NjAuMDYgMTYuODU2OEM4MzQuNDI4IDIzLjI0ODkgOTEwLjY4NiAyOS44MDM1IDEwMjQgOS4zODMzM1oiIGZpbGw9IiMyMzU1NDQiLz4KPC9zdmc+Cg==";
export { SvgBlueFooterTop as ReactComponent };